import React from 'react';

const DialogItem = (props) => {
    return (
    <div>
        {props.name} 
    </div>
    )
}

export default DialogItem;